var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MagCeStaticBlock"},[(_vm.blocks)?[_vm._l((_vm.blocks.elements),function(element,key){return [_c('MagContentRenderer',{key:key,attrs:{"data":element}})]})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }